import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ApplicationService } from '@app/applications/application.service';
import { MatSnackBar } from '@angular/material';
import { ActivatedRoute } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import { OnDestroy } from '@angular/core';
import { LoanDocumentDTO } from '@app/applications/application-details/loanInformation/loan-document/loan-document.model';
@Component({
  selector: 'eng-legal-doc-verification',
  templateUrl: 'legal-document-verification.template.html',
  styleUrls: ['../../../application-details.styles.scss', '../xdata-service.style.scss']
})
export class LegalDocumentVerificationComponent implements OnInit, OnDestroy {

  applicationUid: string;

  maatrumRequestForm: FormGroup;
  legalDocumets: LoanDocumentDTO[] = [];
  showReportHighlight: boolean = false;
  legalDocResponse: any;
  serviceProviderCode: string;


  constructor(private formBuilder: FormBuilder,
    private applicationService: ApplicationService,
    private _snackbar: MatSnackBar,
    private activatedRoute: ActivatedRoute) {
    this.maatrumRequestForm = this.formBuilder.group({
      legalDocument: ['', Validators.required]
    });
    this.activatedRoute.queryParams
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((params) => {
        this.applicationUid = params.applicationUid;
        this.serviceProviderCode = params.xDataService;
    });
  }

  ngOnInit() {
    this.onXDataServiceSelect();
  }

  onXDataServiceSelect(){
    this.applicationService.getAllLegalDocuments(this.applicationUid).subscribe(respose => {
      this.legalDocumets = respose.body;

      if (this.legalDocumets.length === 0 ) {
        this._snackbar.open(
          "Legal document not available to initiate.", "close",
          {
            duration: 5000,
          }
        );
        return;
      }
  
      // if there is only one loanDocumets is captured then we are pre-populating in the dropdown,
      // if there are more than one recored then user need to select from the dropdown 
      if (this.legalDocumets.length === 1 ) {
        this.maatrumRequestForm.patchValue({
          legalDocument: this.legalDocumets[0]
        });
      }
    })
  }

  onInitiateClick(){
    if(this.maatrumRequestForm.valid){
      let legalDocumentUid = this.maatrumRequestForm.controls.legalDocument.value.uid;
    this.applicationService.initiateLegalVerification(this.applicationUid, legalDocumentUid).toPromise().then(
      (_success) => {
      this.legalDocResponse = _success;
        this.showReportHighlight = true;
      this._snackbar.open(this.legalDocResponse.message, "Close", {
        duration: 8000,
      })
    },(failure) => {
      this._snackbar.open(failure , "close", {
        duration: 8000,
      })
  })
    }
  }
  ngOnDestroy(): void {
  }
}
